import { render, staticRenderFns } from "./FooterDrawer.vue?vue&type=template&id=4f935d5a&scoped=true"
import script from "./FooterDrawer.vue?vue&type=script&lang=ts"
export * from "./FooterDrawer.vue?vue&type=script&lang=ts"
import style0 from "./FooterDrawer.vue?vue&type=style&index=0&id=4f935d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f935d5a",
  null
  
)

export default component.exports